import { useSelector } from "react-redux";
import { getLiteTradeAccountMetrics, getLiteTradeAccountPortfolio } from "../LiteTrade/liteTradeSelectors";
import React, { Fragment, useCallback } from "react";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { Accordion, Badge } from "react-bootstrap";
import { AccordionToggle } from "../../components/AccordionToggle/AccordionToggle";
import amountFormat from "../../utils/amountFormat";
import { RespawnPositionsStyled } from "./styled/RespawnPositionsStyled";

export default function RespawnRealPositions() {
    const { getLangPath } = useLangContext();

    const metrics = useSelector(getLiteTradeAccountMetrics);
    const portfolio = useSelector(getLiteTradeAccountPortfolio);

    const plColor = useCallback((amount, pos = null, neg = null) => {
        return <span
            style={{ color: amount > 0 ? 'var(--color-positive)' : amount < 0 ? 'var(--color-negative)' : '' }}>{amount < 0 ? neg || amount : pos || amount}</span>
    }, []);

    if ((!portfolio.positions?.length && !portfolio.orders?.length) || !metrics) {
        return null;
    }

    return <RespawnPositionsStyled>
        <Accordion>
            <Accordion.Item eventKey="0">
                <AccordionToggle
                    eventKey="0">
                    <div className="flex-row justify-content-between">
                        <div><Badge bg={'info'}
                                    className={'me-1'}>{metrics.openPositionsCount + metrics.openOrdersCount}</Badge>
                            {getLangPath('refill.real.positions.title')}
                        </div>
                        <div className={'text-right pl-title'}>{getLangPath('refill.real.positions.pl')} <span
                            className="pl">{plColor(amountFormat(metrics.openPL))}</span>
                        </div>
                    </div>
                </AccordionToggle>
                <Accordion.Body>
                    {
                        metrics.openPositionsCount > 0 &&
                        <div className="position-header">{getLangPath('bonus.new_life.accordion_positions_title')}</div>
                    }
                    {
                        metrics.positions.map(item => <Fragment key={item.positionCode}>
                            <div className="flex-row justify-content-between position-row">
                                <div className={'text-left'}><span
                                    className="symbol">{item.symbol}</span><span
                                    className="side">{plColor(item.quantity, getLangPath('bonus.new_life.position_buy'), getLangPath('bonus.new_life.position_sell'))}</span>
                                </div>
                                <div className={'text-right'}><span
                                    className="pl">{plColor(amountFormat(item.fpl))}</span>
                                </div>
                            </div>
                        </Fragment>)
                    }
                    {
                        metrics.openOrdersCount > 0 && <>
                            <div className="position-header">{getLangPath('bonus.new_life.accordion_orders_title')}</div>
                            {
                                portfolio.orders.map(item => <Fragment key={item.orderId}>
                                    <div className="flex-row justify-content-between position-row">
                                        <div className={'text-left'}><span
                                            className="symbol">{item.instrument}</span><span
                                            className="side">{plColor(item.side === 'BUY' ? 1 : -1, getLangPath('bonus.new_life.position_buy'), getLangPath('bonus.new_life.position_sell'))}</span>
                                        </div>
                                    </div>
                                </Fragment>)
                            }
                        </>
                    }
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </RespawnPositionsStyled>
}
